import { CheckCircle, ExternalLink, Mail, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Layout } from '../components/layout/Layout';

export default function NextSteps() {
  return (
    <Layout>
      <section className="pt-24 pb-24 bg-slate-50 min-h-screen" data-testid="next-steps-page">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
          {/* Success Header */}
          <div className="text-center mb-12">
            <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <CheckCircle className="h-10 w-10 text-teal-600" />
            </div>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-testid="next-steps-heading">
              Thank You for Your Purchase!
            </h1>
            <p className="text-lg text-slate-700">
              Good Evening, I look forward to helping you enhance your credit profile. Please follow the following instructions to begin your process.
            </p>
          </div>

          {/* Step 1 */}
          <Card className="mb-6 border-slate-200 shadow-lg" data-testid="step-1-card">
            <CardContent className="p-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-xl font-bold text-amber-700">1</span>
                </div>
                <div className="flex-1">
                  <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">
                    Sign Up for the Credit Monitor
                  </h2>
                  <p className="text-slate-600 mb-4">
                    Please click the link below and sign up for the Credit Monitor to get started.
                  </p>
                  <a
                    href="https://myfreescorenow.com/enroll/?AID=TamperisSolutions&PID=24113"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block"
                    data-testid="credit-monitor-link"
                  >
                    <Button className="bg-teal-600 hover:bg-teal-700">
                      <ExternalLink className="mr-2 h-4 w-4" />
                      Sign Up for Credit Monitor
                    </Button>
                  </a>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Step 2 */}
          <Card className="mb-6 border-slate-200 shadow-lg" data-testid="step-2-card">
            <CardContent className="p-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-xl font-bold text-amber-700">2</span>
                </div>
                <div className="flex-1">
                  <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">
                    Complete the Onboarding Process
                  </h2>
                  <p className="text-slate-600 mb-4">
                    Please click the link below to complete the Tamperis Solutions onboarding process.
                  </p>
                  <a
                    href="https://www.cognitoforms.com/TamperisSolutionsLLC/TamperisSolutionOnboardingProcess2"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block"
                    data-testid="onboarding-link"
                  >
                    <Button className="bg-amber-600 hover:bg-amber-700">
                      <ExternalLink className="mr-2 h-4 w-4" />
                      Complete Onboarding Form
                    </Button>
                  </a>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Signature */}
          <div className="text-center mt-12 p-8 bg-white rounded-xl border border-slate-200 shadow-sm" data-testid="signature-block">
            <p className="font-heading text-xl font-semibold text-slate-900 mb-1">
              Tamperis Solutions LLC
            </p>
            <a
              href="mailto:support@tampsolution.com"
              className="text-amber-700 hover:underline flex items-center justify-center gap-2"
            >
              <Mail className="h-4 w-4" />
              support@tampsolution.com
            </a>
          </div>

          {/* Back to Home */}
          <div className="text-center mt-8">
            <Link to="/">
              <Button variant="outline" className="border-slate-300 text-slate-700 hover:bg-slate-100">
                Back to Home
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}
